export default __webpack_public_path__ + "static/fullservice-ecc511ad3a2b5a4a62a2d9f3a97cab32.webp";